export default "/images/messaging.jpg?a6cee64c7694a00a8f18e87df456f61c";